import "./karriere.css";
import React, { useState, useEffect } from 'react';
var axios = require('axios');



export default function Karriere({setShowCrew})
 {  

    const [jobs, setJobs] = useState(null)
    useEffect( () => {


var config = {
  method: 'get',
  url: 'https://procuratio.dvinci-hr.com/jobPublication/list.json?fields=small',
  headers: { 
    'Accept': 'application/json',    
  }
};

axios(config)
.then(function (response) {
    setJobs(response.data);
//   console.log(JSON.stringify(response.data));
})
.catch(function (error) {
  console.log(error);
});


    },[])

    return    (

<>
        
          
            <div style={{marginTop: '800px', background: 'white',padding: '15px',  width: '90%', textAlign: 'center'}}><span style={{cursor: 'pointer'}} onClick={()=>setShowCrew(false)}><b><u>Zurück zum Login</u></b></span></div>
          
                <div style={{marginTop: '20px',background: 'white', padding: '15px',  width: '90%'}}>
                      
                          
                      
                      <div style={{width: '100%', textAlign : 'center'}} className="info">
                            <h2 className="topic">Service-Persönlichkeiten gesucht.</h2><p/>
                                    Sind Sie hungrig auf eine Karriere in der Care Catering Branche? Suchen Sie einen Job im Dienstleistungsbereich, 
                                    der für mehr als bloß zum Geldverdienen gut ist? Was darf es bitte sein? Wir bieten Teamplayern 
                                    je nach Neigung und Qualifikation die passende Stelle mit Zukunft und Perspektive. Ob in Voll- oder Teilzeit. 
                                    Beispielsweise als Küchenhilfe, Reinigungskraft oder Koch. Aber auch Führungskräfte im Bereich Objekt- oder 
                                    Betriebsleitung sind bei uns als Unternehmen auf Wachstumskurs immer wieder gefragt.
                                    Echtes Engagement, hohe Zuverlässigkeit und eine ausgeprägte Servicementalität: Das alles erwarten 
                                    wir von jedem Bewerber. Dafür geben wir genauso viel zurück. Gute Arbeitsbedingungen. Nette Kollegen, 
                                    die für echtes Teamwork stehen. Und eine sichere Stelle bei einem der führenden Catering- und 
                                    Reinigungsunternehmen in Deutschland.
                                    Wir sind innovativ, familiär, vielseitig, kommunikativ. Und fühlen uns als Einheit von Individualisten, 
                                    die sich persönlich miteinander verbunden fühlen. Das gemeinsame Ziel: Heute und auch morgen 
                                    den besten Service liefern.<p/><b>Wann lernen wir uns kennen?</b>
                        </div>
              </div>

<div style={{backgroundColor: '#e4ecee', padding: '20px', width: '90%', overflowY: 'scroll', minHeight: '700px', marginTop: '20px'}}>

  { jobs && jobs.map( e => 
  <>
  <div style={{background: 'white', padding: '15px', borderRadius: '10px', display: 'flex', marginBottom: '15px'}}>
        <div style={{width: '50%'}}>
              <div class="jobName"><a href={e.jobPublicationURL} target="_blank">{e.jobOpening.name}</a></div>
              <div  class="jobType">{e.jobOpening.categories[0].name}</div>
        </div>
        <div style={{width: '50%'}}>
              <div class="jobLocation">Standort {e.jobOpening.location}</div>
            <div class="companyName">{ e.jobOpening.company ? e.jobOpening.company.name : '' }</div>
        </div>
    </div>
    </>
     )}

</div>

</>

    )

 }


